import fetch from './fetcher';

export default data => new Promise((resolve, reject) => {
  fetch(`${process.env.REACT_APP_API_URL}/user/login`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data),
  }).then(res => resolve(res)).catch(e => reject(e));
});
